module.exports = {
  "/": {
    "name": "base-editor-path"
  },
  "/:contentId": {
    "success": {
      "main editor loaded": [
        "PARENT_APP_CHROME_RENDERED",
        "INPAGE_EDITOR_READY",
        "ADD_MODULE_SIDEBAR_READY"
      ],
      "main editor loaded no add module sidebar": [
        "PARENT_APP_CHROME_RENDERED",
        "INPAGE_EDITOR_READY",
        "ADD_MODULE_SIDEBAR_NOT_NEEDED"
      ],
      "main editor read only mode": [
        "PARENT_APP_CHROME_RENDERED",
        "READ_ONLY_MODE"
      ]
    },
    "error": [
      "ASYNC_COMPONENT_FAILED_TO_LOAD",
      "ERROR_PAGE_RENDERED"
    ]
  },
  "/:contentId/content": {
    "success": {
      "main editor loaded": [
        "PARENT_APP_CHROME_RENDERED",
        "INPAGE_EDITOR_READY",
        "ADD_MODULE_SIDEBAR_READY"
      ],
      "main editor loaded no add module sidebar": [
        "PARENT_APP_CHROME_RENDERED",
        "INPAGE_EDITOR_READY",
        "ADD_MODULE_SIDEBAR_NOT_NEEDED"
      ],
      "main editor read only mode": [
        "PARENT_APP_CHROME_RENDERED",
        "READ_ONLY_MODE"
      ]
    },
    "error": [
      "ASYNC_COMPONENT_FAILED_TO_LOAD",
      "ERROR_PAGE_RENDERED"
    ]
  },
  "/:contentId/preview": {
    "success": {
      "preview modal loaded": [
        "PARENT_APP_CHROME_RENDERED",
        "PREVIEW_MODAL_RENDERED"
      ]
    },
    "error": [
      "ASYNC_COMPONENT_FAILED_TO_LOAD",
      "ERROR_PAGE_RENDERED"
    ]
  }
};